module.exports = __webpack_public_path__ + "img/private-house-normal.9ef08511.svg";